module.exports = __webpack_public_path__ + "img/code@2x.26c77c16.png";